export enum AddressEnum {
  ZIPCODE = 'zipcode',
  ADDRESS = 'address',
  PREFECTURE = 'prefecture'
}
